import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import bgImg from "../../../Assets/images/home/1HomePage.webp";
import { useTranslation } from "react-i18next";
import HomeInquiryFormModal from "./HomeInquiryFormModal";
import ButtonComponent from "../../../Component/Button/Button";
import { NavRoutes } from "../../../Component/Navbar/NavRoutes";
import { useNavigate } from "react-router-dom";

const HomeSection = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const navigate = useNavigate();

  const userDetails = JSON.parse(localStorage.getItem("Fiesta"));
  const isLoggedIn = Boolean(userDetails);
  const userRole = userDetails?.role;

  const isCustomer = userRole === 1;
  const isPartner = userRole === 2;

  const renderActionButtons = () => {
    return (
      <>
        <ButtonComponent
          label={t("section1.customer")}
          onClick={() => navigate(`${NavRoutes.TRUCKS}/1`)}
          isAnimate={true}
          sx={{
            background: theme.palette.background.orange,
            color: theme.palette.text.defaultLight,
          }}
        />

        {(!isLoggedIn || isCustomer) && (
          <ButtonComponent
            label={t("section1.partner")}
            onClick={() => navigate(NavRoutes.PARTNER)}
            isAnimate={true}
            sx={{
              background: theme.palette.background.btn,
              color: theme.palette.text.defaultLight,
            }}
          />
        )}

        {isPartner && (
          <ButtonComponent
            label={t("section1.button")}
            onClick={handleOpen}
            isAnimate={true}
            sx={{
              background: theme.palette.background.btn,
              color: theme.palette.text.defaultLight,
            }}
          />
        )}
      </>
    );
  };

  return (
    <Box
      sx={{
        height: "calc(100dvh - 76px)",
        width: "100%",
        backgroundImage: `url(${bgImg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <Box
        sx={{
          background: "#1A130C61",
          height: "100%",
          width: "100%",
        }}
        className="flexCenter"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "100%", sm: "90%", md: "90%", lg: "45%" },
            p: 3,
            maxWidth: "1400px",
            // Glassmorphism effect
            background: 'rgba(255, 255, 255, 0.18)',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: '20px',
            border: '1px solid rgba(255, 255, 255, 0.3)',
          }}
        >
          <Box
            sx={{
              gap: { xs: "5px", md: 1, lg: 2 },
              width: {
                xs: "100%",
                sm: "70%",
                md: "50%",
                lg: "100%",
                xl: "85%",
              },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: { xs: "column", lg: "row" },
            }}
          >
            <span
              style={{
                background: theme.palette.background.orange,
                width: "80%",
                height: "1px",
              }}
            />
            <Typography
              variant="h6"
              className="fontSnugle"
              sx={{
                color: theme.palette.text.active,
                fontSize: { xs: "16px", sm: "22px", md: "20px", lg: "18px" },
                width: { md: "700px" },
                textAlign: "center",
              }}
            >
              {t("section1.SubHeadline")}
            </Typography>
            <span
              style={{
                background: theme.palette.background.orange,
                width: "80%",
                height: "1px",
              }}
            />
          </Box>

          <Typography
            variant="h1"
            className="fontSnugle"
            sx={{
              color: theme.palette.text.defaultLight,
              fontSize: { xs: "36px", sm: "55px", md: "69px", xl: "95px" },
              textAlign: "center",
            }}
          >
            {t("section1.Headline")}
          </Typography>

          <Typography
            className="fontSnugle"
            sx={{
              color: theme.palette.text.defaultLight,
              fontSize: { xs: "16px", sm: "20px", md: "30px", xl: "34px" },
              textAlign: "center",
              my: 1,
            }}
          >
            {t("section1.event")}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: { xs: "100%", sm: "60%", md: "50%", lg: "100%" },
            }}
          >
            {["note", "note1", "note2"].map((key) => (
              <Typography
                key={key}
                className="fontSnugle"
                sx={{
                  color: theme.palette.text.greyText,
                  fontSize: { xs: "16px", sm: "18px", md: "20px", xl: "22px" },
                  textAlign: "center",
                }}
              >
                {t(`section1.${key}`)}
              </Typography>
            ))}
          </Box>

          <Box
            sx={{
              pt: "1rem",
              display: "flex",
              gap: { xs: 1, sm: 3 },
              flexWrap: "wrap",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            {renderActionButtons()}
          </Box>

          {(!isLoggedIn || isCustomer) && (
            <Box sx={{ pt: "1rem" }}>
              <ButtonComponent
                label={t("section1.button")}
                onClick={handleOpen}
                isAnimate={true}
                sx={{
                  textDecoration: "underline",
                  // background: theme.palette.background.btn,
                  background: "transparent",
                  color: theme.palette.text.active,
                  "&:hover": {
                    background: "transparent",
                    textDecoration: "underline",
                  },
                }}
              />
            </Box>
          )}

          <HomeInquiryFormModal setOpen={setOpen} open={open} />
        </Box>
      </Box>
    </Box>
    
  );
};

export default HomeSection;
